import { render, staticRenderFns } from "./HomeStepCard.vue?vue&type=template&id=4f22d51d&scoped=true"
import script from "./HomeStepCard.vue?vue&type=script&lang=js"
export * from "./HomeStepCard.vue?vue&type=script&lang=js"
import style0 from "./HomeStepCard.vue?vue&type=style&index=0&id=4f22d51d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f22d51d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
